<template>
	<div class="card border-left-info shadow h-100 py-2">
        <div class="card-body">
            <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                    <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
                        Visitas Hoy 
                        <span
                        class="text-secondary" 
                        v-if="usuario.cliente.id!=null && usuario.cliente.id!='null'">
                            (mi stand)
                        </span>
                    </div>
                    <div 
                    v-if="loading"
                    class="d-flex justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <div 
                    v-else
                    class="h5 mb-0 font-weight-bold text-gray-800">
                        {{visitas}}
                    </div>
                </div>
                <div class="col-auto">
                    <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {firestore} from '@/firebase.js';
import {mapState} from 'vuex';
export default {
    data(){
        return {
            loading:true,
            visitas:0
        }
    },
    methods:{
        ConsultarMisVisitas(){
            var yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            var year_yesterday = yesterday.getFullYear();
            var month_yesterday = yesterday.getMonth()+1;
            var day_yesterday = yesterday.getDate();

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            var year_tomorrow = tomorrow.getFullYear();
            var month_tomorrow = tomorrow.getMonth()+1;
            var day_tomorrow = tomorrow.getDate();

            let start = new Date(year_yesterday+'-'+month_yesterday+'-'+day_yesterday+' 23:59:00');
            let end = new Date(year_tomorrow+'-'+month_tomorrow+'-'+day_tomorrow+' 00:01:00');

            this.visitas=0;
            this.loading=true;
            firestore.collection('total_visitas_por_cliente')
            .where('id','==',this.usuario.cliente.id)
            .where('fecha_hora','>',start)
            .where('fecha_hora','<',end)
            .get().then(querySnapshot=>{
                querySnapshot.forEach(doc=>{
                    this.visitas++;
                });
            }).catch(error=>{
                console.log(error);
            }).finally(response=>{
                this.loading=false;
            });
        },
        ConsultarVisitasTotales(){

            var yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            var year_yesterday = yesterday.getFullYear();
            var month_yesterday = yesterday.getMonth()+1;
            var day_yesterday = yesterday.getDate();

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            var year_tomorrow = tomorrow.getFullYear();
            var month_tomorrow = tomorrow.getMonth()+1;
            var day_tomorrow = tomorrow.getDate();

            let start = new Date(year_yesterday+'-'+month_yesterday+'-'+day_yesterday+' 23:59:00');
            let end = new Date(year_tomorrow+'-'+month_tomorrow+'-'+day_tomorrow+' 00:01:00');

            this.visitas=0;
            this.loading=true;
            firestore.collection('total_visitas')
            .where('fecha_hora','>',start)
            .where('fecha_hora','<',end)
            .get().then(querySnapshot=>{
                querySnapshot.forEach(doc=>{
                    this.visitas++;
                });
            }).catch(error=>{
                console.log(error);
            }).finally(response=>{
                this.loading=false;
            });
        },
    },
    computed:{
        ...mapState(['usuario'])
    },
    created(){
        if (this.usuario.cliente.id!=null && this.usuario.cliente.id!='null') {
            this.ConsultarMisVisitas();
        }else{
            this.ConsultarVisitasTotales();
        }
        
    }
}    
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/visitas_hoy.vue